import { UseMutationOptions, useMutation } from "@tanstack/react-query"
import { AxiosInstance, AxiosResponse } from "axios"
import { IPropsDeleteTeamMember, IResponseDeleteTeamMember } from "./types"
import { useApi } from "@services"
import { DeleteTeamMemberUrl } from "../../../utils/constants"

async function DeleteTeamMember(
	{ userId, userTypeId }: IPropsDeleteTeamMember,
	apiPrivate: AxiosInstance
) {
	try {
		const response: AxiosResponse<IResponseDeleteTeamMember> =
			await apiPrivate.delete(
				`${DeleteTeamMemberUrl}?userId=${userId}&userTypeId=${userTypeId}`
			)
		return response
	} catch (error: any) {
		return error.response
	}
}

export function useDeleteTeamMember(
	options?:
		| Omit<
				UseMutationOptions<
					AxiosResponse<IResponseDeleteTeamMember>,
					unknown,
					unknown,
					AxiosResponse<IResponseDeleteTeamMember>
				>,
				"mutationFn"
		  >
		| undefined
) {
	const { apiPrivate } = useApi()
	const mutation = useMutation({
		mutationFn: (data: IPropsDeleteTeamMember) =>
			DeleteTeamMember(data, apiPrivate),
		...options,
	})
	return mutation
}
